import { useEffect, useState } from "react";

import useData from "../../hooks/useData";

import AutoComplete from "../elements/AutoComplete";

const RetailerSelect = ({ value, onChange }) => {
  const { getFromServer, resultsToOptions } = useData();

  const [options, setOptions] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const results = await getFromServer({ entityName: "Retailer", filter: {} });
    const data = resultsToOptions(results);
    setOptions(data);
  };

  return (
    <AutoComplete
      id={"retailer"}
      label={"retailer"}
      value={value || ""}
      onChange={(newValue) => onChange(newValue)}
      items={options}
    />
  );
};

export default RetailerSelect;
